import React from 'react';
import { StepButton, StepLabel, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export interface StepIconLabelProps {
  title: string;
  isActive: boolean;
  handleStep: () => void;
}

const StepIconLabel = ({ title, isActive, handleStep }: StepIconLabelProps) => {
  const stepStatusIcon = isActive ? (
    <CheckCircleOutlineIcon />
  ) : (
    <CheckCircleIcon />
  );

  return (
    <StepButton color="inherit" icon={stepStatusIcon} onClick={handleStep}>
      <StepLabel>
        <Typography variant="subheadLarge" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </StepLabel>
    </StepButton>
  );
};

export default StepIconLabel;
